module.exports = __webpack_public_path__ + "img/three3Blue.53626926.jpg";